/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiLocationsQueryFromJSON, ApiLocationsQueryToJSON, } from './ApiLocationsQuery';
export function InlineObject5FromJSON(json) {
    return InlineObject5FromJSONTyped(json, false);
}
export function InlineObject5FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'payload': !exists(json, 'payload') ? undefined : ApiLocationsQueryFromJSON(json['payload']),
    };
}
export function InlineObject5ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'payload': ApiLocationsQueryToJSON(value.payload),
    };
}
